import { render, staticRenderFns } from "./WeeklySlotPreference.vue?vue&type=template&id=0bafcc57&scoped=true&"
import script from "./WeeklySlotPreference.vue?vue&type=script&lang=ts&"
export * from "./WeeklySlotPreference.vue?vue&type=script&lang=ts&"
import style0 from "./WeeklySlotPreference.vue?vue&type=style&index=0&id=0bafcc57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bafcc57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VCardText,VCardTitle,VChip})
